import { render } from "./Pagenavi.vue?vue&type=template&id=19038430"
import script from "./Pagenavi.vue?vue&type=script&lang=js"
export * from "./Pagenavi.vue?vue&type=script&lang=js"

import "./Pagenavi.vue?vue&type=style&index=0&id=19038430&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__